import { render, staticRenderFns } from "./listadoDepara.vue?vue&type=template&id=265cf1bf"
import script from "./listadoDepara.vue?vue&type=script&lang=js"
export * from "./listadoDepara.vue?vue&type=script&lang=js"
import style0 from "./listadoDepara.vue?vue&type=style&index=0&id=265cf1bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports